import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Anchor, Box, Button, Text } from '@mantine/core';

import {
  SectionHeader,
  StickyContent,
  TextInputReactRouterSearch,
} from 'components/shared';
import { FormsIcon } from 'icons';

import { useFormsListContext } from '../context';
import { InformationModal } from './InformationModal';

export const Header = () => {
  const { setNewFormWizardOpen } = useFormsListContext();
  const [informationModalOpen, setInformationModalOpen] = useState(false);
  const { t } = useTranslation('forms');

  return (
    <StickyContent hasPageHeaderSpacings>
      <SectionHeader icon={<FormsIcon />}>
        {t('listView.header.title')}
      </SectionHeader>
      <Text sx={theme => ({ marginBottom: theme.other.spacing(4) })} size="md">
        <Trans
          i18nKey="forms:listView.header.description"
          components={{
            a: <Anchor onClick={() => setInformationModalOpen(true)} />,
          }}
        />
      </Text>
      <InformationModal
        opened={informationModalOpen}
        onClose={() => setInformationModalOpen(false)}
      />
      <Box sx={{ display: 'flex' }}>
        <Button color="green" onClick={() => setNewFormWizardOpen(true)}>
          {t('listView.createButton')}
        </Button>
        <TextInputReactRouterSearch
          sx={{
            maxWidth: 328,
            width: '100%',
            marginLeft: 'auto',
          }}
          placeholder={t('listView.searchBarPlaceholder')}
        />
      </Box>
    </StickyContent>
  );
};
